import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom"
import Footer from "../../shared/components/Footer";
import Clinicheader from './Clinicheader';
import { useStateValue } from "../../shared/state/StateProviders";
import Cliniclogin from "./Cliniclogin";
import Topbar from "../../shared/components/Topbar";
import Breadcrumb from "../../shared/components/Breadcrumb";
import ClinicSidebar from "./ClinicSidebar";

export default function Cliniclayout() {

    const [{ CIsLogin }, dispatch] = useStateValue();
    let navigate = useNavigate();

    useEffect(() => {
        if (CIsLogin) {
            // navigate("/administration/dashboard");
        }
    }, [CIsLogin]);





    useEffect(() => {
        if (localStorage.getItem("CToken") !== null && localStorage.getItem("LoginDetails") === 'Clinic') {
            dispatch({
                type: "CLogin",
            });
        } else {
            dispatch({
                type: "CLogout",
            });
        }
    }, []);
    return (<>
        <Topbar />
        <Clinicheader />
        {CIsLogin ?
            <>
                <Breadcrumb />
                <div className="slidebar_and_component">
                    <ClinicSidebar />
                    <div className="outlet_main_div">
                        <Outlet />
                    </div>
                </div>
            </>

            : <Cliniclogin />}
        <Footer />
    </>)
}